<template lang="pug">
  div#app
    div#header
      comp-header
    div#content
      div#left.column
        comp-screen-share
        comp-live-setting
      div#center
        comp-live-stream
      div#right.column
        comp-participants
        comp-chat
    room-device-dialog(ref="roomDeviceDialog" @nextStep="showBeautyPresettingDialog")
    room-beauty-dialog(ref="roomBeautyDialog")
</template>

<script>
import Cookies from 'js-cookie';
import {
  SET_APP_INFO,
  SET_ROOM_ID,
  UPDATE_ROOM_NAME,
  UPDATE_USER_INFO,
} from 'constants/mutation-types';
import {
  getUrlParam,
} from '@/utils/utils';
import {
  getTempAuth,
  getRoomDetail,
  destroyRoom,
  logout,
  tokenLogin,
  keepLive,
} from '@/api/http';
import {
  goToPage,
} from '@/utils/common';
import compHeader from '@/components/comp-header';
import compScreenShare from '@/components/comp-screen-share';
import compLiveSetting from '@/components/comp-live-setting/index.vue';
import compLiveStream from '@/components/comp-live-stream';
import compParticipants from '@/components/comp-participants';
import compChat from '@/components/comp-chat';
import roomDeviceDialog from '@/components/comp-pre-setting/room-device-dialog.vue';
import roomBeautyDialog from '@/components/comp-pre-setting/room-beauty-dialog.vue';
import { mapState } from 'vuex';
export default {
  name: 'App',
  components: {
    compHeader,
    compScreenShare,
    compLiveSetting,
    compLiveStream,
    compParticipants,
    compChat,
    roomBeautyDialog,
    roomDeviceDialog,
  },
  computed: {
    ...mapState({
      roomId: 'roomId',
      userInfo: 'userInfo',
    }),
  },
  methods: {
    // 显示设置预设置弹窗
    showDevicePresettingDialog() {
      this.$refs.roomDeviceDialog.handleShowDeviceDialog();
    },
    // 显示美颜预设置弹窗
    showBeautyPresettingDialog() {
      this.$refs.roomBeautyDialog.handleShowBeautyDialog();
    },
    doKeepLive(userId, token) {
      setInterval(() => {
        keepLive({
          userId,
          token,
        });
      }, 10 * 1000);
    },
    async handlePage() {
      let token = Cookies.get('trtc-tuiPusher-token');
      const userInfo = JSON.parse(localStorage.getItem('trtc-tuiPusher-userInfo'));
      if (!token || !userInfo) {
        goToPage('login');
      }
      const { sdkAppId, userId, userName, userAvatar } = userInfo;
      this.$store.commit(UPDATE_USER_INFO, {
        userId,
        userName,
        userAvatar,
      });
      const roomId = parseInt(getUrlParam('roomId'), 10);
      this.$store.commit(SET_ROOM_ID, roomId);
      // 获取用户的 userSig
      let { userSig } = userInfo;
      const userSigResult = await tokenLogin({
        userId,
        token,
      });
      if (userSigResult.errorCode === 0) {
        userSig = userSigResult.data.sdkUserSig;
        token = userSigResult.data.token;
        Cookies.set('trtc-tuiPusher-token', token);
      }
      // 获取屏幕分享用户的 userSig
      const shareUserSigResult = await getTempAuth({
        userId: userInfo.userId,
        token,
        givenUserId: `share_${userInfo.userId}`,
      });
      if (shareUserSigResult.errorCode === 0) {
        const { sdkUserSig: shareUserSig } = shareUserSigResult.data;
        this.$store.commit(SET_APP_INFO, {
          sdkAppId,
          userSig,
          shareUserSig,
        });
      }
      // 获取房间信息
      const result = await getRoomDetail({
        userId: userInfo.userId,
        token,
        roomId,
      });
      if (result.errorCode === 0) {
        const { category, ownBy, title: roomName } = result.data;
        if (category !== 'web-tuiPusher&tuiPlayer' || ownBy !== userInfo.userId) {
          goToPage('create-room');
        }
        this.$store.commit(UPDATE_ROOM_NAME, roomName);
        // 每 10s 发送心跳包
        this.doKeepLive(userId, token);
      } else {
        goToPage('create-room');
      }
    },
    // 退出直播间
    async handleExit() {
      const token = Cookies.get('trtc-tuiPusher-token');
      // 退出 room service 房间
      await destroyRoom({
        userId: this.userInfo.userId,
        token,
        roomId: this.roomId,
      });
      // 页面跳转
      goToPage('create-room');
    },
    // 退出登录
    async handleLogout() {
      const token = Cookies.get('trtc-tuiPusher-token');
      await logout({
        userId: this.userInfo.userId,
        token,
      });
      Cookies.remove('trtc-tuiPusher-token');
      localStorage.removeItem('trtc-tuiPusher-userInfo');
      localStorage.removeItem('trtc-tuiPusher-roomInfo');
      goToPage('login');
    },
  },
  async created() {
    await this.handlePage();
    this.$eventBus.$on('exit', this.handleExit);
    this.$eventBus.$on('logout', this.handleLogout);
  },
  mounted() {
    this.showDevicePresettingDialog();
  },
  beforeDestroy() {
    this.$eventBus.$off('exit', this.handleExit);
    this.$eventBus.$off('logout', this.handleLogout);
  },
};
</script>

<style lang="stylus">
@import '~assets/style/black-element-ui.styl';
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  --webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  width 100%
  height 100%
  position relative
  color $fontColor
  div#header
    width 100%
    height 50px
    background-color $backgroundColor
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.20);
  div#content
    position absolute
    top 50px
    width 100%
    left 0
    bottom 0
    display flex
    background-color $backgroundColor
    div#left
      width 20%
      min-width 300px
      max-width 406px
      height 100%
      background-color $themeColor
    div#center
      height 100%
      flex-grow 1
    div#right
      width 20%
      min-width 300px
      max-width 406px
      height 100%
      background-color $themeColor
    .column
      padding 8px
      display flex
      flex-direction column
      > div:not(:first-child)
        margin-top 8px
      > div:last-child
        flex-grow 1
</style>
